var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.336 0h13.33v1.333H.335V0zM3.668 3.332h6.665v1.333H3.668V3.332zM5.001 6.665H9v1.333H5.001V6.665z",
    fill: "#25241D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE0IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjMzNTkzOCAwSDEzLjY2NTJWMS4zMzI5M0gwLjMzNTkzOFYwWiIgZmlsbD0iIzI1MjQxRCIvPgo8cGF0aCBkPSJNMy42NjgyNSAzLjMzMjMySDEwLjMzMjlWNC42NjUyNEgzLjY2ODI1VjMuMzMyMzJaIiBmaWxsPSIjMjUyNDFEIi8+CjxwYXRoIGQ9Ik01LjAwMTE4IDYuNjY0NjNIOC45OTk5NlY3Ljk5NzU2SDUuMDAxMThWNi42NjQ2M1oiIGZpbGw9IiMyNTI0MUQiLz4KPC9zdmc+Cg==";
export { SvgSort as ReactComponent };